import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

export function Button(props) {
  const handleButtonClick = (event) => () => {
    const {onClick} = props;
    onClick(event);
  };
  function getWrapperClassName() {
    return `buttonStyle ${props.className}`;
  }
  return (
    <button
      className={getWrapperClassName()}
      aria-label={props.ariaLabel}
      onClick={handleButtonClick()}
      tabIndex={props.tabIndex}
      disabled={props.disabled}>
      {props.children}
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.any,
};

Button.defaultProps = {
  onClick: () => {},
  ariaLabel: '',
  disabled: false,
};
